import {useSwitchAccount} from "../../components/switch-account/switch-account-store";
import {useEffect} from "react";
import {Navigate} from "react-router-dom";

export const InitSwitchAccountPage = () => {
  const {enableSwitchAccount, isSwitching} = useSwitchAccount();
  useEffect(() => {
    enableSwitchAccount();
  }, []);
  if (isSwitching) {
    return <Navigate to="/switch" />;
  }
  return null;
};